import React, { useState } from 'react';
import "./Home6.css"

const Home6 = ({ onButtonClick, galleryTitle="Gallery" }) => {
  return (
    <div className='home-6-main-container-1'>
        <div className="home-6-sub-container-2">

        </div>
    </div>
  )
}

export default Home6